/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { htmlspecialchars, copyToClipboard } from './util.js';
import { $ } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';
import { mj } from './page-mj.js';
import { startProgress, stopProgress } from './progress-util.js';
import { postToBackend2 } from './fetch-util.js';

var g_current_toast_idx = 0;
var g_info_toast_elements = [];
var g_info_toast_options = [];
const g_toast_max_elements = 3;
const g_toast_max_elements_with_callbacks = 9;
const g_toast_default_options = {
	text_type: 'text',
	timeout: 5000,
	callbacks: [],
	undoToken: null,
	undoCallback: null
};

const g_timeout_of_toast_with_undo = 10 * g_toast_default_options.timeout;
const g_timeout_of_plain_warning_toast = 10 * g_toast_default_options.timeout;
/*let callback_default = {
	title: 'test',
	callback: function(element, button) {}
};*/
export function showInfoToastWithLink( infoText, linkURL, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	let html = infoText;
	if(all_options.text_type == 'text') html = htmlspecialchars(infoText);
	if( linkURL ) {
		html += '<br>'
			+'<a class="link toast-link" target="_blank" href="'+htmlspecialchars(linkURL,true,true)+'">'
			+ htmlspecialchars(linkURL)
			+'</a>';
	}

	const buttonCopy2Clipboard = all_options.buttonCopy2Clipboard ?? false;
	if( buttonCopy2Clipboard ) {
		all_options.callbacks.push( {
			title: mjt('md-link-info-copy'),
			callback: function( $element, $button ) {
				$button.find('.label').html('<span class="icon"></span>'+htmlspecialchars(mjt('md-link-info-copied')));
				copyToClipboard(linkURL);
				setTimeout( function() {
					$button.find('.label').text(htmlspecialchars(mjt('md-link-info-copy')));
					$button.hide().show(0);
				}, 3000 );
			}
		} );
	}
	all_options.text_type = 'html';
	return showInfoToast(html, all_options);
}
export function showInfoToast( infoText, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	if( all_options.text_type==='text' ) infoText = htmlspecialchars(infoText);
	if( all_options.undoCallback ) {
		if( all_options.timeout === g_toast_default_options.timeout ) {
			all_options.timeout = g_timeout_of_toast_with_undo;
		}
		all_options.callbacks.push( {
			title: mjt('revert'),
			callback: function( $element, $button ) {
				startProgress();
				postToBackend2('json/media/undo-undo', { token:all_options.undoToken }, function(j) {
					stopProgress();
					const undoDone = function( j, x_options ) {
						if( j && j.success ) {
							x_options.undoCallback();
						} else if( j.error )  {
							showWarningToast(j.error);
							_destroy_undoToken(x_options.undoToken);
						}
					};
					_removeToast(
						$element,
						'undoDone',
						true,
						function _undoDoneRemoveToastDoneCb( idx, type, x_options ) {
							undoDone(j,x_options);
						},
						function _undoDoneRemoveToastErrCb() {
							undoDone(j,all_options);
						}
					);
				});
			}
		} );
	}
	return _showToast('info', infoText, all_options);
}
export function showErrorToast( errorText, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	if( !( typeof options === 'object' && options.hasOwnProperty('timeout') ) ) {
		// dont auto-close errors (except when timeout was explicitely specified in options)
		all_options.timeout = 0;
	}
	if( all_options.text_type==='text' ) errorText = htmlspecialchars(errorText);
	return _showToast('error', errorText, all_options);
}
export function showWarningToast( warnText, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	if( !( typeof options === 'object' && options.hasOwnProperty('timeout') ) ) {
		// dont auto-close warnings (except when timeout was explicitely specified in options)
		// all_options.timeout = 0;
		all_options.timeout = g_timeout_of_plain_warning_toast;
	}
	if( all_options.text_type==='text' ) warnText = htmlspecialchars(warnText);
	return _showToast('warning', warnText, all_options);
}

function _destroy_undoToken( token ) {
	postToBackend2('json/media/undo-clean', { token }, function(j) {
	});
}




function _removeToast( $thisToastElem, reasonText, skipUndoToken, doneCb, errCb ) {
	if( $thisToastElem==null ) {
		// skip ..
		if( errCb ) {
			errCb();
		}
		return;
	}
	const thisToastElemData = $thisToastElem.data();
	const thisToastElemIdx = thisToastElemData.idx ?? 0;
	const thisToastElemType = thisToastElemData.type ?? '';
	const thisToastElemTimer = thisToastElemData.timer ?? 0;
	const thisToastElemOptions = g_info_toast_options[thisToastElemIdx] ?? null;

	// console.log({
	// 	w:'_removeToast',
	// 	thisToastElemIdx,
	// 	reasonText,
	// 	skipUndoToken,
	// 	undoToken: JSON.stringify(thisToastElemOptions?(thisToastElemOptions.undoToken??null):null),
	// 	thisToastElemType,
	// 	thisToastElemTimer,
	// 	thisToastElemOptions,
	// });

	if( thisToastElemTimer ) {
		clearTimeout(thisToastElemTimer);
	}

	if( thisToastElemType === 'info' ) {
		if( (g_info_toast_elements[thisToastElemIdx]??null)!=null ) {
			g_info_toast_elements[thisToastElemIdx].remove();
		}
		g_info_toast_elements[thisToastElemIdx] = null;
		g_info_toast_options[thisToastElemIdx] = null;
	} else {
		$thisToastElem.remove();
	}

	if( !skipUndoToken && thisToastElemOptions && thisToastElemOptions.undoToken ) {
		_destroy_undoToken(thisToastElemOptions.undoToken);
	}
	if( doneCb ) {
		doneCb(thisToastElemIdx,thisToastElemType,thisToastElemOptions);
	}
}

function _addNewToast( idx, $newToastElem, options ) {
	$newToastElem.attr('data-idx',idx);

	g_info_toast_elements[idx] = $newToastElem;
	g_info_toast_options[idx] = options;

	const new_idx = (idx+1) % g_toast_max_elements;
	return new_idx;
}

function _createNewToastElem( idx, type, html, options, real_timeout ) {
	let $newToastElem = $('<div class="toast-element"'
							+' data-type="'+type+'"'
							+' data-idx="'+idx+'"'
							+' data-timeout="'+(real_timeout??0)+'"'
							+'>'
							+'<div class="'+type+'"></div>'
							+'<div class="content">'+html+'</div>'
							+'<div class="close"></div>'
							+'<div class="timeline"></div>'
						+'</div>');
	$newToastElem.on( 'click', '.close', function() {
		const $thisToastElem = $(this).closest('.toast-element');
		_removeToast($thisToastElem,'click');
	} );
	return $newToastElem;
}


function _showToast( type, html, options ) {
	if( mj.info_hook ) {
		mj.info_hook.apply(this, Array.prototype.slice.call(arguments));
	}

	let real_timeout = options.timeout * (options.callbacks.length ? 3 : 1);

	if( ( type==='error' || type==='warning' ) && real_timeout===0 && options.callbacks.length===0 ) {
		// if same error as last one, then add a repeat counter instead of new toast:
		const $prevToastElem = $('#toast > .toast-element').last();
		if( $prevToastElem.length && $prevToastElem.data('type')===type && $prevToastElem.data('timeout')==0 ) {
			const $contentElem = $prevToastElem.find('.content');
			if( $contentElem.html() === html ) {
				const $repeatElem = $prevToastElem.find('.repeat');
				if( $repeatElem.length===0 ) {
					$contentElem.after( $('<div class="repeat" data-count="2">x 2</div>') );
				} else {
					const count = $repeatElem.data('count');
					$repeatElem.data('count',count+1).text('x '+(count+1));
				}
				return;
			}
		}
	}


	let $newToastElem = _createNewToastElem(g_current_toast_idx,type,html,options,real_timeout);

	if( type === 'info' ) {

		// find a slot (preferably one without a "revert" callback )...
		while( g_current_toast_idx < g_toast_max_elements_with_callbacks ) {
			const prevToastOptions = g_info_toast_options[g_current_toast_idx] ?? null;
			if( prevToastOptions===null ) {
				break; // free slot
			}
			if( !prevToastOptions.callbacks.length || prevToastOptions.callbacks.length===0 ) {
				break; // slot without callbacks -> accept
			}
			// try next slot
			++ g_current_toast_idx;
		}

		const $prevToastElem = g_info_toast_elements[g_current_toast_idx] ?? null;
		_removeToast($prevToastElem,'replaceSlot');
		options._dbg_type = type;
		options._dbg_html = html;
		options._dbg_g_current_toast_idx = g_current_toast_idx;

		g_current_toast_idx = _addNewToast(g_current_toast_idx,$newToastElem,options);

	}

	$('#toast').append($newToastElem);

	if( options.timeout ) {
		const timer = setTimeout( function _toastTimedOut() {
			_removeToast($newToastElem,'timeout');
		}, real_timeout );
		$newToastElem.data('timer',timer);
		setTimeout(function() {
			$newToastElem.find('.timeline').addClass('move').css('transition', 'width '+parseInt((real_timeout-1000)/1000)+'s');
		}, 1000);
	} else {
		$newToastElem.find('.timeline').css('display', 'none');
	}

	if( options.callbacks.length ) {
		for( let i=0; i<options.callbacks.length; i++ ) {
			const entry = options.callbacks[i];
			const $button = $('<button class="" type="button"><span class="left"></span><span class="label">'
					+htmlspecialchars(entry.title)
					// +'<span class="small">: '+JSON.stringify(options.undoToken)+'</span>'
					+'</span><span class="right"></span></button>');
			$button.on('click', function() {
				const $thisButton = $(this);
				const $thisToastElem = $thisButton.closest('.toast-element');
				// console.log({w:'callback click',entry, $newToastElem,$thisToastElem, $button,$thisButton});
				entry.callback($thisToastElem,$thisButton);
			} );
			if( i===0 ) $button.addClass('primary_action');
			else $button.addClass('secondary_action');
			$button.insertBefore($newToastElem.find('.close'));
		}
	}
	return true;
}


